import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import customizationReducer from './customizationReducer'
import userReducer from './userReducer'
import dialogReducer from './dialogReducer'
import noteReducer from './noteReducer'

const persistConfig = {
  key: 'root',
  rehydrated: true,
  version: -1,
  storage,
  // blacklist: ['customization'],
  // stateReconciler: hardSet,
  // whitelist: ['customization', 'user']
  // whitelist: ['user', 'ploy', 'realties', 'realtiesIndividual']
  whitelist: ['user', 'notes']
}


const reducer = combineReducers({
  customization: customizationReducer,
  user: userReducer,
  dialog: dialogReducer,
  notes: noteReducer
})

export default persistReducer(persistConfig, reducer)
